module.exports = __webpack_public_path__ + "img/story005@2x.da51b185.webp";